{
  "fr": {
    "markdownEditor": {
      "toolbar": "Mise en forme",
      "bold": "Gras",
      "italic": "Italique",
      "heading": "Titre",
      "bulletList": "Liste à puces",
      "orderedList": "Liste numérotée",
      "center": "Centrer",
      "details": "Section repliable",
      "detailsCollapse": "Replier la section",
      "detailsExpand": "Déplier la section",
      "link": "Lien",
      "linkUrl": "Adresse du lien",
      "linkUrlPlaceholder": "https://…",
      "linkApply": "Appliquer",
      "linkRemove": "Supprimer le lien",
      "linkInvalid": "Seules les adresses http(s) ou les chemins de ce site peuvent être liés.",
      "image": "Image",
      "imageAlt": "Description de l'image",
      "imageApply": "Insérer",
      "close": "Fermer",
      "source": "Modifier la source Markdown",
      "imageUploadFailed": "L'image n'a pas pu être envoyée. Réessayez.",
      "imageTitle": "Insérer une image",
      "imageAltHint": "Lue à la place de l'image, et affichée si elle ne peut pas être chargée.",
      "cancel": "Annuler",
      "imageSize": "Taille de l'image",
      "imageSize25": "Petite",
      "imageSize50": "Moyenne",
      "imageSize75": "Grande",
      "imageSizeFull": "Pleine largeur",
      "item": "Article du catalogue",
      "itemSearchHint": "Tapez le nom d'un article",
      "itemSearchEmpty": "Aucun article répertorié de ce nom",
      "itemType": {
        "Component": "Composant",
        "Equipment": "Équipement",
        "Commodity": "Marchandise",
        "Model": "Vaisseau",
        "Blueprint": "Plan",
        "GameMission": "Mission",
        "Location": "Lieu",
        "FleetContract": "Contrat",
        "FleetEvent": "Événement",
        "User": "Utilisateur"
      }
    }
  }
}
